import {
  Formatters
} from 'guaxinim-web'

export const agrupamentoDefaultDesktop = ["C", "D", "F", "N"]
export const agrupamentoDefaultMobile = ["C", "D", "F", "N"]
export const tiposAgrupamento = [
  {
    label: 'Unid. Negócio',
    value: 'A'
  },
  {
    label: 'Grupo Alpha7',
    value: 'B'
  },
  {
    label: 'Depto. Nível 1',
    value: 'C'
  },
  {
    label: 'Depto. Nível 2',
    value: 'D'
  },
  {
    label: 'Gestão Nível 1',
    value: 'E'
  },
  {
    label: 'Gestão Nível 2',
    value: 'F'
  },
  {
    label: 'Ramo Atividade',
    value: 'G'
  },
  {
    label: 'Investimento',
    value: 'H'
  },
  {
    label: 'Avaliação',
    value: 'I'
  },
  {
    label: 'Indicador',
    value: 'N'
  }]
export const cores = {
  corNaoSeAplica: '#35caed',
  corErro: '#8461f7',
  corPessimo: '#fc3333',
  corRuim: '#ec7a08',
  corBom: '#f0ab00',
  corOtimo: '#92d400',
  corExcelente: '#3f9c35',
}

export const tiposAvaliacao = [
  { description: 'Excelente', value: 'A' },
  { description: 'Ótimo', value: 'B' },
  { description: 'Bom', value: 'C' },
  { description: 'Ruim', value: 'D' },
  { description: 'Péssimo', value: 'E' },
  { description: 'Erro', value: 'F' },
  { description: 'Não se aplica', value: 'G' }
]

export const legendColor = value => {
  if (!value && value!==0)
    return cores.corNaoSeAplica
  else if (value >= 90)
    return cores.corExcelente
  else if (value >= 70)
    return cores.corOtimo
  else if (value >= 50)
    return cores.corBom
  else if (value >= 30)
    return cores.corRuim
  else
    return cores.corPessimo
}

export const formatarValorMedia = (valor, unidadeMedida) =>
  (valor === undefined || valor === null || !unidadeMedida)
    ? '' : `${Formatters.decimalFormat.format(valor)} (${unidadeMedida})`
